import z from 'zod';

export const listOf = <T extends z.ZodTypeAny>(schema: T) => z.array(schema);

export const encodeAll = <T extends z.ZodTypeAny, U extends z.core.output<T> = z.output<T>>(schema: T, ...records: Array<U>) => {
	return records.map((record) => schema.encode(record));
};
